export const DataService = {
  item0: 0,
  item1: {
    id: 1,
    title: "Infrastructures",
    cover: "assets/images/services/infrastructures/cover.png",
    desc: "Ce département étudie et réalise les projets d’énergie couvrant la production, le transport, la distribution de l’énergie électrique et également la construction de centrales solaires photovoltaïques, Groupes électrogènes et hybrides. Ce département apporte aussi aux opérateurs de téléphonie mobile, aux équipementiers et intégrateurs télécoms des solutions énergétiques durables. Ses champs d’actions sont les suivants :",
    actions: [
      {
        id: 1,
        action:
          "Construction d’infrastructures lignes et postes HTB/HTA et HTA/BTA ; ",
      },
      { id: 2, action: "Electrification rurale et urbaine ; " },
      {
        id: 3,
        action:
          "Construction et maintenance de Centrales électriques (Groupes électrogènes, solaires  photovoltaïques et sites hybrides) ;",
      },
      {
        id: 4,
        action: "Alimentation de secours (Groupes Electrogènes et Onduleurs) ;",
      },
      {
        id: 5,
        action:
          "Travaux neufs et maintenance énergie de sites Télécoms (Indoor et Outdoor) ; ",
      },
      {
        id: 6,
        action:
          "Installation et maintenance de systèmes d’énergie et de ventilation des Data centers ;",
      },
      {
        id: 7,
        action:
          "Contrats de maintenance énergie (Disponibilité en énergie 24h/24) ; ",
      },
      {
        id: 8,
        action:
          "Fabrication et installation de cuves carburant 1000 à 50 000 L ; ",
      },
      {
        id: 9,
        action: "Ingénierie, études & conseils dans le domaine de l’énergie. ",
      },
    ],
    gallery: [
      {
        id: 1,
        img: "assets/images/services/infrastructures/1.jpg",
      },
      {
        id: 2,
        img: "assets/images/services/infrastructures/2.jpg",
      },
      {
        id: 3,
        img: "assets/images/services/infrastructures/3.jpg",
      },
      {
        id: 4,
        img: "assets/images/services/infrastructures/4.jpg",
      },
      {
        id: 5,
        img: "assets/images/services/infrastructures/5.jpg",
      },
      {
        id: 6,
        img: "assets/images/services/infrastructures/6.jpg",
      },
      {
        id: 7,
        img: "assets/images/services/infrastructures/7.jpg",
      },
      {
        id: 8,
        img: "assets/images/services/infrastructures/8.jpg",
      },
    ],
  },
  item2: {
    id: 2,
    title: "Industrie",
    cover: "assets/images/services/industrie/cover.png",
    desc: "Le département Industrie gère les projets d’électricité, d’automatisme industriel, d’instrumentation, de Machines électriques et de constructions industrielles. Elle intervient dans tous les secteurs de l’industrie. Voici quelques domaines concernés : ",
    actions: [
      {
        id: 1,
        action:
          "Réalisation de tableaux électriques (Coffrets et armoires électriques) ; ",
      },
      {
        id: 2,
        action:
          "Automatisation process (Installation et mise en œuvre des Automates Siemens, Schneider Electric, Omron, Allen Bradley…) ; ",
      },
      {
        id: 3,
        action: "Télégestion de sites et d’unités industrielles ;",
      },
      {
        id: 4,
        action:
          "Installation et maintenance de variateurs de vitesse Siemens, Schneider Electric, ABB… ; ",
      },
      {
        id: 5,
        action: "Machines électriques (Installation et maintenance) ; ",
      },
      {
        id: 6,
        action: "Mise en réseau des Automates ; ",
      },
      {
        id: 7,
        action: "Migration WinCC, Tia Portal – Profibus et Profinet ; ",
      },
      {
        id: 8,
        action:
          "Instrumentation (Installation de capteurs de niveau, de température, de pression et d’humidité) ; ",
      },
      {
        id: 9,
        action:
          "Installation et maintenance de Groupes Froids (Daikin, Carrier, Haier…) ; ",
      },
      {
        id: 10,
        action:
          "Construction industrielle (Conception 2D et 3D, travaux mécaniques, montage d’usine, charpente métallique, tuyauteries, reconditionnement d’équipements industriels…). ",
      },
    ],
    gallery: [
      {
        id: 1,
        img: "assets/images/services/industrie/1.jpg",
      },
      {
        id: 2,
        img: "assets/images/services/industrie/2.jpg",
      },
      {
        id: 3,
        img: "assets/images/services/industrie/3.jpg",
      },
      {
        id: 4,
        img: "assets/images/services/industrie/4.jpg",
      },
      {
        id: 5,
        img: "assets/images/services/industrie/5.jpg",
      },
      {
        id: 6,
        img: "assets/images/services/industrie/6.jpg",
      },
      {
        id: 7,
        img: "assets/images/services/industrie/7.jpg",
      },
      {
        id: 8,
        img: "assets/images/services/industrie/8.jpg",
      },
    ],
  },
  item3: {
    id: 3,
    title: "Building Technologies",
    cover: "assets/images/services/building_technologies/cover.png",
    desc: "Le département Building Technologies s’oriente vers les solutions énergétiques pour le Bâtiment. Il touche les activités suivantes : ",
    actions: [
      {
        id: 1,
        action: "Installation électrique courant fort (230 / 400 V) ;",
      },
      {
        id: 2,
        action:
          " Installation électrique courant faible (Vidéosurveillance, contrôle d’accès, internet, wifi, Téléphone, interphone, Télévision, sécurité incendie…) ; ",
      },
      {
        id: 3,
        action:
          "Installation Froid & Climatisation (Split mural, centralisé, groupe froid, système d’eau glacée…) ; ",
      },
      {
        id: 4,
        action:
          "Installation plomberie sanitaire (Eau potable, eau chaude, évacuation eau usée…) ;",
      },
    ],
    gallery: [
      {
        id: 1,
        img: "assets/images/services/building_technologies/1.jpg",
      },
      {
        id: 2,
        img: "assets/images/services/building_technologies/2.jpg",
      },
      {
        id: 3,
        img: "assets/images/services/building_technologies/3.jpg",
      },
      {
        id: 4,
        img: "assets/images/services/building_technologies/4.jpg",
      },
      {
        id: 5,
        img: "assets/images/services/building_technologies/5.jpg",
      },
      {
        id: 6,
        img: "assets/images/services/building_technologies/6.jpg",
      },
      {
        id: 7,
        img: "assets/images/services/building_technologies/7.jpg",
      },
      {
        id: 8,
        img: "assets/images/services/building_technologies/8.jpg",
      },
    ],
  },
  item4: {
    id: 4,
    title: "Matériels Industriels",
    cover: "assets/images/services/materiels_industriels/cover.png",
    desc: "Le Département distribution de matériels industriels importe et faire la vente de matériels industriels et équipements spécifiques suivants : ",
    actions: [
      {
        id: 1,
        action:
          "Les disjoncteurs masterpact Schneider Electric jusqu’à 2000 A ;",
      },
      {
        id: 2,
        action:
          "Les compresseurs Atlas Copco et COMPAIR de puissance 2,2 à 250 KW ;",
      },
      {
        id: 3,
        action: "Les onduleurs APC, RIELLO UPS 10 à 6400 KVA ; ",
      },
      {
        id: 4,
        action: "Les régulateurs de tension IREM, ORTEA… ; ",
      },
      {
        id: 5,
        action: "Lampadaires solaires ;",
      },
      {
        id: 6,
        action: "Baies d’énergie et Batteries Backup ;",
      },
      {
        id: 7,
        action:
          "Les variateurs de vitesse type Schneider Electric, ABB, Siemens ;",
      },
      {
        id: 8,
        action:
          "Les machines électriques (Moteurs asynchrones, machines à courant continu, transformateurs…) ;",
      },
      {
        id: 9,
        action: "Les motopompes jusqu’à 320 m3/H ; ",
      },
      {
        id: 10,
        action: "Pompes immergées ; ",
      },
      {
        id: 11,
        action:
          "Groupes Electrogènes à usage tertiaire et industriel (Cummins, Caterpillar, SDMO Koller) ; ",
      },
      {
        id: 12,
        action:
          "Pièces de rechange de Groupes Electrogènes (Caterpillar, Cummins, SDMO KOHLER, Jenbacher…) ;",
      },
      {
        id: 13,
        action: "Cuves carburant 1000 à 50 000 L; ",
      },
      {
        id: 14,
        action: "Confection de Flexibles gasoil haute pression, embouts… ; ",
      },
      {
        id: 15,
        action:
          "Coffrets et armoires précablés, inverseurs de source jusqu’à 1200 A ;",
      },
      {
        id: 16,
        action:
          "Les Automates (Schneider Electric, Siemens, Allen Bradley) et assistance à la mise en œuvre ;",
      },
      {
        id: 17,
        action: "Conteneurs Bureaux.",
      },
    ],
    gallery: [
      {
        id: 1,
        img: "assets/images/services/materiels_industriels/1.jpg",
      },
      {
        id: 2,
        img: "assets/images/services/materiels_industriels/2.jpg",
      },
      {
        id: 3,
        img: "assets/images/services/materiels_industriels/3.jpg",
      },
      {
        id: 4,
        img: "assets/images/services/materiels_industriels/4.jpg",
      },
      {
        id: 5,
        img: "assets/images/services/materiels_industriels/5.jpg",
      },
      {
        id: 6,
        img: "assets/images/services/materiels_industriels/6.jpg",
      },
      {
        id: 7,
        img: "assets/images/services/materiels_industriels/7.jpg",
      },
      {
        id: 8,
        img: "assets/images/services/materiels_industriels/8.jpg",
      },
      {
        id: 9,
        img: "assets/images/services/materiels_industriels/9.jpg",
      },
      {
        id: 10,
        img: "assets/images/services/materiels_industriels/10.jpg",
      },
      {
        id: 11,
        img: "assets/images/services/materiels_industriels/11.jpg",
      },
      {
        id: 12,
        img: "assets/images/services/materiels_industriels/12.jpg",
      },
      {
        id: 13,
        img: "assets/images/services/materiels_industriels/13.jpg",
      },
      {
        id: 14,
        img: "assets/images/services/materiels_industriels/14.jpg",
      },
      {
        id: 15,
        img: "assets/images/services/materiels_industriels/15.jpg",
      },
      {
        id: 16,
        img: "assets/images/services/materiels_industriels/16.jpg",
      },
      {
        id: 17,
        img: "assets/images/services/materiels_industriels/17.jpg",
      },
      {
        id: 18,
        img: "assets/images/services/materiels_industriels/18.jpg",
      },
      {
        id: 19,
        img: "assets/images/services/materiels_industriels/19.jpg",
      },
      {
        id: 20,
        img: "assets/images/services/materiels_industriels/20.jpg",
      },
      {
        id: 21,
        img: "assets/images/services/materiels_industriels/21.jpg",
      },
      {
        id: 22,
        img: "assets/images/services/materiels_industriels/22.jpg",
      },
    ],
  },
};

export const DataServiceOne = {
  title: "NOS DEPARTEMENTS",
  subTitle: "",
  items: [
    {
      id: DataService.item1.id,
      delay: 1,
      icon: "assets/images/services/agency-6.svg",
      title: DataService.item1.title,
      desc: "Ce département étudie et réalise les projets d’énergie couvrant la production, le transport, la distribution de l’énergie électrique ...",
    },
    {
      id: DataService.item2.id,
      delay: 3,
      icon: "assets/images/services/agency-1.svg",
      title: DataService.item2.title,
      desc: "Ce département les projets d’électricité, d’automatisme industriel, d’instrumentation, de  Machines électriques et de constructions industrielles...",
    },
    {
      id: DataService.item3.id,
      delay: 5,
      icon: "assets/images/services/agency-2.svg",
      title: DataService.item3.title,
      desc: "Le département Building Technologies s’oriente vers les solutions énergétiques pour le Bâtiment...",
    },
    {
      id: DataService.item4.id,
      delay: 7,
      icon: "assets/images/services/agency-3.svg",
      title: DataService.item4.title,
      desc: "Le Département distribution de matériels industriels importe et faire la vente de matériels industriels et équipements...",
    },
  ],
  description: "  ",
  btnDesc: "Vous souhaitez en savoir plus sur nous ?",
  btnName: "Click here",
  btnLink: "/a_propos",
};

export const DataServicePageSec1 = {
  title: "",
  subTitle: "",
  items: [
    {
      id: DataService.item1.id,
      delay: 1,
      icon: "assets/images/services/agency-6.svg",
      title: DataService.item1.title,
      desc: "Ce département étudie et réalise les projets d’énergie couvrant la production, le transport, la distribution de l’énergie électrique ...",
    },
    {
      id: DataService.item2.id,
      delay: 3,
      icon: "assets/images/services/agency-1.svg",
      title: DataService.item2.title,
      desc: "Ce département les projets d’électricité, d’automatisme industriel, d’instrumentation, de  Machines électriques et de constructions industrielles...",
    },
    {
      id: DataService.item3.id,
      delay: 5,
      icon: "assets/images/services/agency-2.svg",
      title: DataService.item3.title,
      desc: "Le département Building Technologies s’oriente vers les solutions énergétiques pour le Bâtiment...",
    },
    {
      id: DataService.item4.id,
      delay: 7,
      icon: "assets/images/services/agency-3.svg",
      title: DataService.item4.title,
      desc: "Le Département distribution de matériels industriels importe et faire la vente de matériels industriels et équipements...",
    },
  ],
  description: " ",
  btnDesc: "",
  btnName: "",
  btnLink: "",
};
